import { render, staticRenderFns } from "./BWCSystem.vue?vue&type=template&id=25fbfec6&scoped=true"
import script from "./BWCSystem.vue?vue&type=script&lang=js"
export * from "./BWCSystem.vue?vue&type=script&lang=js"
import style0 from "./BWCSystem.vue?vue&type=style&index=0&id=25fbfec6&prod&lang=scss"
import style1 from "./BWCSystem.vue?vue&type=style&index=1&id=25fbfec6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25fbfec6",
  null
  
)

export default component.exports